/* 三图模式 */
export const isThreeImage = item => {
    return item.thumbnails && item.thumbnails !== '' && item.thumbnails.image.length >= 3;
};

/* 一图模式 */
export const isOneImage = item => {
    return (
        item.thumbnails &&
        item.thumbnails !== '' &&
        item.thumbnails.image.length < 3 &&
        item.thumbnails.image.length > 0
    );
};

/* 有图 */
export const haveImage = item => {
    return (
        (item.thumbnails && item.thumbnails !== '' && item.thumbnails.image.length > 0) ||
        (item.thumbnail && item.thumbnail !== '')
    );
};

/* 获取图片地址 */
export const getImageUrl = item => {
    return 'picUrl' in item ? item.picUrl : item.url;
};

/* 图片比例计算 */
const width = typeof window === 'object' ? window.innerWidth : null;

export const imageAttr = function imageAttr(num) {
    if (width === null) {
        return num;
    } else {
        return parseInt((width / 750) * num);
    }
};
